'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { Button } from '@/components/ui/button';
import { memo } from 'react';
import type { VisibilityType, } from './visibility-selector';
// Session type definition for stateless mode
type Session = null;
import Image from 'next/image';
import { SidebarTrigger } from '@/components/ui/sidebar';

function PureChatHeader({
  chatId,
  selectedVisibilityType,
  isReadonly,
  session,
}: {
  chatId: string;
  selectedVisibilityType: VisibilityType;
  isReadonly: boolean;
  session: Session;
}) {
  const _router = useRouter();

  return (
    <header className='sticky top-0 flex items-center justify-between border-b bg-white px-4 py-3 shadow-sm'>
      {/* Logo and Brand */}
      <div className="flex items-center gap-3">
        <SidebarTrigger />
        <Link href="https://allmanager.fr/" className="flex items-center gap-2">
          <Image
            src="/logo/AM-logo-1.svg"
            alt="All Manager Logo"
            width={120}
            height={28}
            className="h-7 w-auto"
          />
        </Link>
      </div>

      {/* Navigation Menu */}
      <nav className='hidden items-center gap-8 md:flex'>
        <Link href="https://allmanager.fr/" className='text-gray-700 transition-colors hover:text-blue-600'>
          Accueil
        </Link>
        <Link href="https://allmanager.fr/erp/" className='text-gray-700 transition-colors hover:text-blue-600'>
          ERP
        </Link>
        <Link href="https://allmanager.fr/all-manager-votre-organisme-de-formation/" className='text-gray-700 transition-colors hover:text-blue-600'>
          Académie
        </Link>
        <Link href="https://allmanager.fr/a-propos/" className='text-gray-700 transition-colors hover:text-blue-600'>
          À propos
        </Link>
      </nav>

      {/* Right Side Actions */}
      <div className="flex items-center gap-3">
        <Link
          href="/login"
          className='hidden text-gray-700 transition-colors hover:text-blue-600 md:block'
        >
          Connexion
        </Link>
        
        <Button
          className='rounded-md bg-blue-600 px-4 py-2 text-white transition-colors hover:bg-blue-700'
          asChild
        >
          <Link href="/contact">
            Contact
          </Link>
        </Button>
      </div>
    </header>
  );
}

export const ChatHeader = memo(PureChatHeader, (prevProps, nextProps) => {
  return (
    prevProps.chatId === nextProps.chatId &&
    prevProps.selectedVisibilityType === nextProps.selectedVisibilityType &&
    prevProps.isReadonly === nextProps.isReadonly
  );
});
